import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10 px-12 pt-0" }
const _hoisted_2 = { class: "flex justify-left font-bold border-solid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("u", null, "Back", -1)
const _hoisted_4 = { class: "flex justify-center font-bold border-solid pt-6" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", {
  class: "text-lg font-russo leading-6 pb-2 font-medium text-gray-900",
  id: "modal-title"
}, " UNSUBSCRIBE ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, " If you do not wish to receive updates about our latest arrivals by email, please enter your email below: ", -1)
const _hoisted_8 = {
  key: 1,
  class: "mt-8 sm:mt-5"
}
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-lg my-4 text-green-500 bg-green-100 border-2 rounded border-green-500" }
const _hoisted_12 = { class: "m-2" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "text-lg my-4 text-red-500" }
const _hoisted_15 = { class: "mx-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ClipLoader = _resolveComponent("ClipLoader")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        class: "cursor-pointer hover:text-red-600",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToHomePage && _ctx.backToHomePage(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'chevron-left'],
          class: "pr-2"
        }),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_ClipLoader, {
              key: 0,
              class: "mt-8 sm:mt-5",
              color: _ctx.colorLoading
            }, null, 8, ["color"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", null, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    class: "shadow appearance-none border rounded w-full sm:w-1/2 py-2 px-3 text-gray-900",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                    type: "text",
                    placeholder: "Enter email...",
                    onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.unsubscribe && _ctx.unsubscribe(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.unsubscribe && _ctx.unsubscribe(...args))),
                    class: "mt-8 sm:mt-6 inline-flex justify-center w-1/2 rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:text-sm"
                  }, " Submit ")
                ]),
                (_ctx.isUnsubscribed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.message), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("p", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.message), 1)
                      ])
                    ]))
              ])
            ]))
      ])
    ])
  ]))
}